import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonChamili';
const args = {};

export class OligonChamili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
